/* eslint-disable jsx-a11y/anchor-is-valid */
import {KTIcon} from '../../../../../../../_metronic/helpers'
import {StepProps} from '../IAppModels'

const Step1 = ({data, updateData, hasError, errorMessage}: StepProps) => {
  return (
    <div className='current' data-kt-stepper-element='content'>
      <div className='w-100'>
        {/*begin::Form Group */}
        <div className='fv-row mb-10'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Protocolo</span>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            name='protocol'
            placeholder='Digite o número do protocolo'
            autoComplete='off'
            value={data.protocol}
            onChange={(e) =>
              updateData({
                protocol: e.target.value,
              })
            }
          />
          {hasError && (
            <div className='fv-plugins-message-container'>
              <div data-field='protocol' data-validator='notEmpty' className='fv-help-block'>
                {errorMessage}
              </div>
            </div>
          )}
        </div>
        {/*end::Form Group */}
      </div>
    </div>
  )
}

export {Step1}
